import { API_ENDPOINT } from './config';

const PHD_API_ENDPOINT = `${API_ENDPOINT}/phd`;

export const urlsPhd = {
  phdStudents: `${PHD_API_ENDPOINT}/students`,
  phdStudentDetail: (id) => `${PHD_API_ENDPOINT}/students/${id}`,
  phdStudentMe: `${PHD_API_ENDPOINT}/students/me`,
  phdStudentDeadlines: (id) => `${PHD_API_ENDPOINT}/students/${id}/deadlines`,
  phdStudentDeadlineAdjustments: (id) =>
    `${PHD_API_ENDPOINT}/students/${id}/deadline-adjustments`,
  phdStudentInterruptions: (id) =>
    `${PHD_API_ENDPOINT}/students/${id}/interruptions`,
  phdStudyInterruptionResume: (id) =>
    `${PHD_API_ENDPOINT}/interruptions/${id}/resume`,
  phdStudyInterruptionCorrection: (id) =>
    `${PHD_API_ENDPOINT}/interruptions/${id}/correct`,
  phdDashboard: `${PHD_API_ENDPOINT}/dashboard`,
  phdSchoolYearTransition: `${PHD_API_ENDPOINT}/school-year-transition`,
  phdSchoolYearTransitionPreview: `${PHD_API_ENDPOINT}/school-year-transition/preview`,
  phdIndividualPlans: `${PHD_API_ENDPOINT}/individual-plans`,
  phdIndividualPlanDetail: (id) => `${PHD_API_ENDPOINT}/individual-plans/${id}`,
  phdIndividualPlanDocument: (id) =>
    `${PHD_API_ENDPOINT}/individual-plans/${id}/document`,
  phdIndividualPlanDocumentArchive: (id) =>
    `${PHD_API_ENDPOINT}/individual-plans/${id}/document/archive`,
  phdIndividualPlanTasks: `${PHD_API_ENDPOINT}/individual-plan-tasks`,
  phdIndividualPlanTaskDetail: (id) =>
    `${PHD_API_ENDPOINT}/individual-plan-tasks/${id}`,
  phdIndividualPlanSubjects: `${PHD_API_ENDPOINT}/individual-plan-subjects`,
  phdTheses: `${PHD_API_ENDPOINT}/theses`,
  phdThesisDetail: (id) => `${PHD_API_ENDPOINT}/theses/${id}`,
  phdThesisDocument: (id) => `${PHD_API_ENDPOINT}/theses/${id}/document`,
  phdThesisFile: (id, type) => `${PHD_API_ENDPOINT}/theses/${id}/file/${type}`,
  phdThesesDocument: `${PHD_API_ENDPOINT}/theses/document`,
  phdDocumentTemplates: `${PHD_API_ENDPOINT}/document-templates`,
  phdDocumentTemplateDetail: (key) =>
    `${PHD_API_ENDPOINT}/document-templates/${key}`,
  phdDocumentTemplatePreview: (key) =>
    `${PHD_API_ENDPOINT}/document-templates/${key}/preview`,
  phdDocumentVariables: `${PHD_API_ENDPOINT}/document-variables`,
  phdDocumentVariableDetail: (id) =>
    `${PHD_API_ENDPOINT}/document-variables/${id}`,
  phdThesesBulkApprove: `${PHD_API_ENDPOINT}/theses/bulk-approve`,
  phdThesesManualDefense: `${PHD_API_ENDPOINT}/theses/manual-defense`,
  phdThesisApprove: (id) => `${PHD_API_ENDPOINT}/theses/${id}/approve`,
  phdThesisDefend: (id) => `${PHD_API_ENDPOINT}/theses/${id}/defend`,
  phdThesisDeny: (id) => `${PHD_API_ENDPOINT}/theses/${id}/deny`,
  phdThesisArchive: (id) => `${PHD_API_ENDPOINT}/theses/${id}/archive`,
  phdThesisRestore: (id) => `${PHD_API_ENDPOINT}/theses/${id}/restore`,
  phdThesisDuplicate: (id) => `${PHD_API_ENDPOINT}/theses/${id}/duplicate`,
  phdThesisReplace: (id) => `${PHD_API_ENDPOINT}/theses/${id}/replace`,
  phdStudentEvaluations: `${PHD_API_ENDPOINT}/student-evaluations`,
  phdStudentEvaluationDetail: (id) =>
    `${PHD_API_ENDPOINT}/student-evaluations/${id}`,
  phdStudentEvaluationDocument: (id) =>
    `${PHD_API_ENDPOINT}/student-evaluations/${id}/document`,
  phdStudentEvaluationDocumentArchive: (id) =>
    `${PHD_API_ENDPOINT}/student-evaluations/${id}/document/archive`,
  phdStudentEvaluationGrades: `${PHD_API_ENDPOINT}/student-evaluation-grades`,
  phdStudentEvaluationGradeDetail: (id) =>
    `${PHD_API_ENDPOINT}/student-evaluation-grades/${id}`,
  phdDissertationExamApplications: `${PHD_API_ENDPOINT}/exam-applications`,
  phdDissertationExamApplicationDetail: (id) =>
    `${PHD_API_ENDPOINT}/exam-applications/${id}`,
  phdDissertationExamApplicationSubmit: (id) =>
    `${PHD_API_ENDPOINT}/exam-applications/${id}/submit`,
  phdDissertationExamApplicationDocument: (id) =>
    `${PHD_API_ENDPOINT}/exam-applications/${id}/document`,
  phdDissertationExamExaminerProposals: `${PHD_API_ENDPOINT}/exam-examiner-proposals`,
  phdDissertationExamExaminerProposalDetail: (id) =>
    `${PHD_API_ENDPOINT}/exam-examiner-proposals/${id}`,
  phdDissertationExamExaminerProposalDocument: (id) =>
    `${PHD_API_ENDPOINT}/exam-examiner-proposals/${id}/document`,
  phdDissertationExamExaminerProposalDocumentArchive: (id) =>
    `${PHD_API_ENDPOINT}/exam-examiner-proposals/${id}/document/archive`,
  phdDissertationDefenseApplications: `${PHD_API_ENDPOINT}/defense-applications`,
  phdDissertationDefenseApplicationDetail: (id) =>
    `${PHD_API_ENDPOINT}/defense-applications/${id}`,
  phdDissertationDefenseApplicationSubmit: (id) =>
    `${PHD_API_ENDPOINT}/defense-applications/${id}/submit`,
  phdDissertationDefenseApplicationDocument: (id) =>
    `${PHD_API_ENDPOINT}/defense-applications/${id}/document`,
  phdDissertationDefenseExaminerProposals: `${PHD_API_ENDPOINT}/defense-examiner-proposals`,
  phdDissertationDefenseExaminerProposalDetail: (id) =>
    `${PHD_API_ENDPOINT}/defense-examiner-proposals/${id}`,
  phdDissertationDefenseExaminerProposalDocument: (id) =>
    `${PHD_API_ENDPOINT}/defense-examiner-proposals/${id}/document`,
  phdDissertationDefenseExaminerProposalDocumentArchive: (id) =>
    `${PHD_API_ENDPOINT}/defense-examiner-proposals/${id}/document/archive`,
  phdSubjectsExamApplications: `${PHD_API_ENDPOINT}/subjects-exam-applications`,
  phdSubjectsExamApplicationDetail: (id) =>
    `${PHD_API_ENDPOINT}/subjects-exam-applications/${id}`,
  phdSubjectsExamApplicationSubmit: (id) =>
    `${PHD_API_ENDPOINT}/subjects-exam-applications/${id}/submit`,
  phdSubjectsExamApplicationDocument: (id) =>
    `${PHD_API_ENDPOINT}/subjects-exam-applications/${id}/document`,
  phdSchoolYears: `${PHD_API_ENDPOINT}/school-years`,
  phdSupervisors: `${PHD_API_ENDPOINT}/supervisors`,
  phdSupervisorDetail: (id) => `${PHD_API_ENDPOINT}/supervisors/${id}`,
  phdSupervisorCandidates: `${PHD_API_ENDPOINT}/supervisors/candidates`,
  phdSupervisorReference: `${PHD_API_ENDPOINT}/supervisors/reference`,
  phdComments: `${PHD_API_ENDPOINT}/comments`,
  phdCommentDetail: (id) => `${PHD_API_ENDPOINT}/comments/${id}`,
  phdSystemStates: `${PHD_API_ENDPOINT}/system-states`,
  phdSystemStateCurrent: `${PHD_API_ENDPOINT}/system-states/current`,
  phdWorkingGroups: `${PHD_API_ENDPOINT}/working-groups`,
  phdWorkingGroupDetail: (id) => `${PHD_API_ENDPOINT}/working-groups/${id}`,
  phdStudyFields: `${PHD_API_ENDPOINT}/study-fields`,
  phdStudyFieldDetail: (id) => `${PHD_API_ENDPOINT}/study-fields/${id}`,
  phdStudySubjects: `${PHD_API_ENDPOINT}/study-subjects`,
  phdStudySubjectDetail: (id) => `${PHD_API_ENDPOINT}/study-subjects/${id}`,
};

export const routesPhd = {
  // Public

  phdThesesPublic: '/dizertacne-prace',
  phdThesisPublicDetail: '/dizertacne-prace',

  // CMS
  cmsPhdDashboard: '/cms/phd-dashboard',
  cmsPhdCommentsEdit: '/cms/phd-comments/edit',
  cmsPhdCommentsCreate: '/cms/phd-comments/create',
  cmsPhdStudents: '/cms/phd-students',
  cmsPhdStudentsEdit: '/cms/phd-students/edit',
  cmsPhdStudentsCreate: '/cms/phd-students/create',
  cmsPhdSupervisors: '/cms/phd-supervisors',
  cmsPhdSupervisorsEdit: '/cms/phd-supervisors/edit',
  cmsPhdSupervisorsCreate: '/cms/phd-supervisors/create',
  cmsPhdTheses: '/cms/phd-theses',
  cmsPhdThesesEdit: '/cms/phd-theses/edit',
  cmsPhdThesesCreate: '/cms/phd-theses/create',
  cmsPhdThesesDefend: '/cms/phd-theses/defend',
  cmsPhdThesesManualDefense: '/cms/phd-theses/manual-defense',
  cmsPhdThesesDetail: '/cms/phd-theses/detail',
  cmsPhdSettings: '/cms/phd-settings',
  cmsPhdSystemState: '/cms/phd-system-state',
  cmsPhdIndividualPlans: '/cms/phd-individual-plans',
  cmsPhdIndividualPlansEdit: '/cms/phd-individual-plans/edit',
  cmsPhdIndividualPlansCreate: '/cms/phd-individual-plans/create',
  cmsPhdStudentEvaluations: '/cms/phd-student-evaluations',
  cmsPhdStudentEvaluationsEdit: '/cms/phd-student-evaluations/edit',
  cmsPhdStudentEvaluationsCreate: '/cms/phd-student-evaluations/create',
  cmsPhdStudentEvaluationGrades: '/cms/phd-student-evaluation-grades',
  cmsPhdStudentEvaluationGradesEdit: '/cms/phd-student-evaluation-grades/edit',
  cmsPhdStudentEvaluationGradesCreate:
    '/cms/phd-student-evaluation-grades/create',
  cmsPhdApplications: '/cms/phd-applications',
  cmsPhdMyApplications: '/cms/phd-my-applications',
  cmsPhdApplicationsCreate: '/cms/phd-applications/create',
  cmsPhdDissertationExamApplications: '/cms/phd-applications/dissertation-exam',
  cmsPhdDissertationDefenseApplications:
    '/cms/phd-applications/dissertation-defense',
  cmsPhdSubjectsExamApplications: '/cms/phd-applications/subjects-exam',
  cmsPhdExaminerProposals: '/cms/phd-examiner-proposals',
  cmsPhdDissertationExamExaminerProposals: '/cms/phd-examiner-proposals/exam',
  cmsPhdDissertationDefenseExaminerProposals:
    '/cms/phd-examiner-proposals/defense',
  cmsPhdDissertationExamApplicationsEdit:
    '/cms/phd-dissertation-exam-applications/edit',
  cmsPhdDissertationExamApplicationsCreate:
    '/cms/phd-dissertation-exam-applications/create',
  cmsPhdDissertationExamExaminerProposalsEdit:
    '/cms/phd-dissertation-exam-examiner-proposals/edit',
  cmsPhdDissertationExamExaminerProposalsCreate:
    '/cms/phd-dissertation-exam-examiner-proposals/create',
  cmsPhdDissertationDefenseApplicationsEdit:
    '/cms/phd-dissertation-defense-applications/edit',
  cmsPhdDissertationDefenseApplicationsCreate:
    '/cms/phd-dissertation-defense-applications/create',
  cmsPhdDissertationDefenseExaminerProposalsEdit:
    '/cms/phd-dissertation-defense-examiner-proposals/edit',
  cmsPhdDissertationDefenseExaminerProposalsCreate:
    '/cms/phd-dissertation-defense-examiner-proposals/create',
  cmsPhdSubjectsExamApplicationsEdit:
    '/cms/phd-subjects-exam-applications/edit',
  cmsPhdSubjectsExamApplicationsCreate:
    '/cms/phd-subjects-exam-applications/create',
  cmsPhdStudentPlan: '/cms/phd-student-plan',
  cmsPhdStudyFields: '/cms/phd-study-fields',
  cmsPhdStudyFieldsEdit: '/cms/phd-study-fields/edit',
  cmsPhdStudyFieldsCreate: '/cms/phd-study-fields/create',
  cmsPhdWorkingGroups: '/cms/phd-working-groups',
  cmsPhdWorkingGroupsEdit: '/cms/phd-working-groups/edit',
  cmsPhdStudySubjectsEdit: '/cms/phd-study-subjects/edit',
  cmsPhdStudySubjectsCreate: '/cms/phd-study-subjects/create',
};
